export default __webpack_public_path__ + "static/media/markersByMarkRabeOnUnsplash.69d145fb.jpg";